@if (style === 'home') {
  <div class="dash-icon {{ color ? color : '' }} d-flex flex-column align-items-center">
    <div class="icon-container {{ orientation === 'bottomRight' ? 'bottom-right' : orientation === 'bottomLeft' ? 'bottom-left' : orientation === 'topRight' ? 'top-right' : 'top-left' }} position-relative">
      <div class="background-layer"></div>
      <div class="foreground-layer">
        <div class="icon">
          <span class="mts-icon notranslate" translate="no">{{ icon }}</span>
        </div>
      </div>
      @if (badge) {
        <span class="e-badge e-badge-danger e-badge-overlap e-badge-notification"></span>
      }
    </div>
    <div class="icon-text text-center">{{ title }}</div>
  </div>
}

@if (style === 'homeIcons') {
  <span class="mts-icon notranslate icon-size {{ color ? 'text-' + color : '' }}" translate="no">{{ icon }}</span>
}

@if (style === 'barTop') {
  <button type="button" class="btn btn-link p-1 text-primary position-relative">
    <span class="mts-icon notranslate fs-4 {{ danger ? 'text-danger' : '' }}" translate="no">{{ icon }}</span>
    @if (alert) {
      <span class="badge-dot position-absolute top-0 translate-middle p-1 bg-danger rounded-circle"></span>
    }
  </button>
}

@if (style === 'plainIcon') {
  <span class="mts-icon notranslate p-m" translate="no">{{ icon }}</span>
}

@if (style === 'plainIconSidePadding') {
  <span class="mts-icon notranslate px-1" translate="no">{{ icon }}</span>
}

@if (style === 'link') {
  <span class="mts-icon notranslate lh-1" translate="no">{{ icon }}</span>
}

@if (style === 'noContent') {
  <span class="mts-icon notranslate fs-3 text-white" translate="no">{{ icon }}</span>
}

@if (style === 'noContentSmall') {
  <span class="mts-icon notranslate fs-5 text-darkblue p-1" translate="no">{{ icon }}</span>
}

@if (style === 'notification') {
  <button class="btn btn-link p-0 {{fontColor}}" [class.text-muted]="!fontColor">
    <span class="mts-icon notranslate fs-5 {{ class }}" translate="no">{{ icon }}</span>
    <span class="visually-hidden">{{ screenReaderText }}</span>
  </button>
}

@if (style === 'documents') {
  <span class="upload-icon fs-1 mts-icon notranslate text-secondary me-3" translate="no">cloud_upload</span>
}

@if (style === 'documentsFolder') {
  <span class="file-folder-icon-size mts-icon mts-icon-filled notranslate text-warning lh-base" translate="no">folder</span>
}

@if (style === 'default') {
  <span class="mts-icon notranslate {{ fontSize }} {{ fontColor }} {{ lineHeight }} {{ class }}" translate="no">{{ icon }}</span>
}
